import { FilterHandler } from 'app/shared/filter-handler';
import { Model } from './model';
import { Shipowner } from './shipowner';

import * as moment from 'moment';

class NotificationRecipient extends Model {
  id: number;
  read_status: string;
  shipowner: Shipowner;
  read_status_label: string;
  attached_files: Object[] = [];

  apiMap(values: Object = {}) {
    const nr = new NotificationRecipient(values);

    if (values['shipowner']) {
      nr.shipowner = new Shipowner().apiMap(values['shipowner']);
    }

    return nr;
  }
}

export class NotificationSender extends Model {
  id: number;
  key: string;
  name: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new NotificationSender(values);
  }
}
export class NotificationFile extends Model {
  id: number;
  file: File;
  notification: NotificationFile;
  name: String;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new NotificationFile(values);
  }
}

export class Notification extends Model {
  id: number;
  created: moment.Moment;
  sended: moment.Moment;
  subject: string;
  body: string;
  status: string;
  status_label: string;
  sender: NotificationSender = new NotificationSender();
  sender_label: string;
  attached_files: NotificationFile[];

  recipients: NotificationRecipient[];
  recipientsIDs: string[] = [];

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const notification = new Notification(values);
    notification.mapRecipients(values);
    notification.mapFiles(values);

    if (values['sender']) {
      notification.sender = new NotificationSender().apiMap(values['sender']);
    }
    return notification;
  }

  mapRecipients(values: Object = {}) {
    if (values['recipients']) {
      this.recipients = [];
      values['recipients'].forEach((item) => {
        this.recipients.push(new NotificationRecipient().apiMap(item));
      });

      this.recipientsIDs = [];
      this.recipients.forEach((item) => {
        this.recipientsIDs.push(`${item.shipowner.id}`);
      });
    }
  }
  mapFiles(values: Object = {}) {
    if (values['attached_files']) {
      this.attached_files = [];
      values['attached_files'].forEach((item) => {
        this.attached_files.push(new NotificationFile().apiMap(item));
      });
    }
  }

  isRecipient(shipowner: Shipowner) {
    return this.recipientsIDs.includes(`${shipowner.id}`);
  }

  isRead(shipowner: Shipowner) {
    let leido;
    this.recipients.forEach((item) => {
      if (item.shipowner.id === shipowner.id) {
        if (String(item.read_status) === 'read') {
          leido = true;
        } else {
          leido = false;
        }
      }
    });
    return leido;
  }

  isDraft() {
    return this.status === 'draft';
  }

  public serialize() {
    const record = {};
    for (const key of Object.keys(this)) {
      record[key] = this[key];
    }
    record['sender'] = this.sender && this.sender.id;

    return record;
  }
}

export class NotificationFilter extends FilterHandler {
  search: string;
  status: string;
  sender: string;

  start_date: string;
  end_date: string;

  constructor(values: Object = {}) {
    super();

    this.search = '';
    this.status = '';
    this.sender = '';
    this.start_date = '';
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/notification.ts